<template>
  <div class="container section-menu-page">
    <div class="section-title-wrap">
      <h2 class="section-title">{{ labels.title }}</h2> 
    </div>
    <div>
      <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
        <!-- ===== SPINNER DE CARGA ===== -->
        <div v-if="isLoading" class="table-corporate-loading-state">
          <div class="table-corporate-empty-card">
            <div class="modern-spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
            </div>
            <p class="mt-2 mb-0">Cargando...</p>
          </div>
        </div>

        <!-- ===== CONTENIDO ===== -->
        <b-container v-else style="padding: 18px 40px 40px;">
          <b-row
            id="home-buttons"
            v-for="subMenu in visibleSubmenus"
            :key="subMenu.id || subMenu.ruta"
          >
            <b-col md="4" class="p-2 admin-menu-card-col" col="3">
              <button
                type="button"
                class="md-card admin-menu-card-button"
                @click="goToRoute(subMenu)"
              >
                <div>
                  <div>
                    <div class="md-title-tarjeta">
                      <span>{{ subMenu?.nombre }}</span> 
                    </div>
                  </div>
                </div>
              </button>
            </b-col>
            <b-col md="8" class="p-2" col="3">
              <div md-with-hover class="div-description">
                <div>
                  <div>
                    <div class="md-title-description">
                      <span>{{ subMenu?.descripcion }}</span> 
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../services/Menu'; 
import SubMenu from '../../services/SubMenu'; 

export default {
  name: "Administrador",
  data: () => ({
    niif: "",
    descripcion: "",
    listaSubMenu: [],
    isLoading: true
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Administrador",
          users: "Usuarios",
          usersd: "Administración de Usuarios",
          menu: "Menús",
          descripMenu: "Administración de Menús",
          subMenu: "Submenús",
          descripSubMenu: "Administración de submenus",
          roles: "Roles",
          descripRole: "Administración de Roles",
          cargues: "Cargues",
          carguesd: "Definición de formatos de cargues",
          buttonControl: "Panel de Control",
          buttonControld: "Administración de controles por componente y rol",
        }
      } else {
        return {
          title: "Administrator",
          users: "Users",
          usersd: "Users Administration",
          menu: "Menus",
          descripMenu: "Menus Administration",
          subMenu: "Submenus management",
          descripSubMenu: "submenus description",
          roles: "Role",
          descripRole: "Role Administration",
          cargues: "Uploads",
          carguesd: "Upload Format Definition",
          buttonControl: "Control Panel",
          buttonControld: "Control management by component and role",
        }
      }
    },
    visibleSubmenus() {
      return this.listaSubMenu.length > 0 ? this.listaSubMenu : this.buildFallbackSubmenus()
    }
  },
  methods: {
    goToRoute(subMenu) {
      const targetRoute = this.resolveRoute(subMenu)
      if (!targetRoute) return
      
      const routeExists = this.$router.getRoutes().some(route => route.path === targetRoute)
      if (!routeExists) {
        console.error(`La ruta ${targetRoute} no existe en el router`)
        this.$toast?.error(`La ruta ${targetRoute} no está disponible`)
        return
      }
      this.$router.push(targetRoute)
    },
    resolveRoute(subMenu) {
      const rawPath = String(subMenu?.ruta || "").trim()
      const rawName = String(subMenu?.nombre || "").trim().toLowerCase()
      const normalizedPath = rawPath
        ? (rawPath.startsWith("/") ? rawPath : `/${rawPath}`)
        : ""

      const routeMapByName = {
        usuarios: "/users",
        user: "/users",
        users: "/users",
        menús: "/menus",
        menus: "/menus",
        submenús: "/submenus",
        submenus: "/submenus",
        roles: "/roles",
        cargues: "/cargueFormato",
        cargue: "/cargueFormato",
        "panel de control": "/buttonControlAdm",
        "control panel": "/buttonControlAdm",
        buttoncontrol: "/buttonControlAdm",
      }

      return routeMapByName[rawName] || normalizedPath || null
    },
    buildFallbackSubmenus() {
      return [
        {
          id: "usuarios",
          nombre: this.labels.users,
          descripcion: this.labels.usersd,
          ruta: "/users",
        },
        {
          id: "menus",
          nombre: this.labels.menu,
          descripcion: this.labels.descripMenu,
          ruta: "/menus",
        },
        {
          id: "submenus",
          nombre: this.labels.subMenu,
          descripcion: this.labels.descripSubMenu,
          ruta: "/submenus",
        },
        {
          id: "roles",
          nombre: this.labels.roles,
          descripcion: this.labels.descripRole,
          ruta: "/roles",
        },
        {
          id: "cargues",
          nombre: this.labels.cargues,
          descripcion: this.labels.carguesd,
          ruta: "/cargueFormato",
        },
        {
          id: "buttoncontrol",
          nombre: this.labels.buttonControl,
          descripcion: this.labels.buttonControld,
          ruta: "/buttonControlAdm",
        },
      ]
    },
    async loadSubmenus() {
      this.isLoading = true
      
      try {
        const menusResponse = await Menu.getAllMenu()
        const menus = menusResponse?.data?.listMenu || []
        const adminMenu = menus.find((menu) => {
          const route = String(menu?.ruta || "").toLowerCase()
          const name = String(menu?.nombre || "").toLowerCase()
          return route === "administrador" || route === "/administrador" || name === "administrador"
        })
        const menuId = adminMenu?.id || 2
        const res = await SubMenu.subMenuByMenuByRol(menuId, this.$store.state.userRole)
        this.listaSubMenu = (res?.data?.submenus || []).map((item) => ({
          ...item,
          ruta: this.resolveRoute(item),
        }))
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    }
  },
  mounted() {
    this.loadSubmenus()
  },
  // ===== IMPORTANTE: Reseteamos el estado al salir del componente =====
  beforeDestroy() {
    this.isLoading = false
    this.listaSubMenu = []
  },
  // ===== Si usas keep-alive, usa estos en su lugar =====
  // activated() {
  //   this.loadSubmenus()
  // },
  // deactivated() {
  //   this.isLoading = false
  // }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ===== SPINNER ===== */
.modern-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  margin: 0 auto;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner-ring:nth-child(1) {
  border-top-color: #1f4f83;
  animation-delay: -0.45s;
}

.spinner-ring:nth-child(2) {
  border-right-color: #4a90d9;
  animation-delay: -0.3s;
}

.spinner-ring:nth-child(3) {
  border-bottom-color: #7fb3e6;
  animation-delay: -0.15s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.table-corporate-loading-state {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  padding: 20px;
  background: rgba(255, 255, 255, 0.7);
}

.table-corporate-empty-card {
  width: 100%;
  max-width: 480px;
  padding: 28px 32px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e4e8ed;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}

.table-corporate-empty-card p {
  color: #6c757d;
  font-size: 14px;
}
</style>